<div class="md:tw-min-w-[770px] sm:tw-w-[500px] tw-w-[350px]">
  <!-- title -->
  <ng-container *ngIf="isShowDialogTitle">
    <app-modal-title [isShowClose]="true" (isCloseModal)="onClose()">
    </app-modal-title>
  </ng-container>

  <div mat-dialog-content class="dialog-content">
    <form-generator [isModalMode]="true" [formsConfig]="fieldsData">
    </form-generator>
  </div>
</div>
